export default "__VITE_ASSET__c6d7be7f__"